import type {ActionResponseWithText, AnyObject, CapabilityName, DocumentCapabilitySlotsRequest, LoanRequestFormActionResponse, LoanRequestItem, LoanRequestTypes, RedirectionResponse} from 'src/typings';
import type {KpUniversalFormSettings} from 'shared/value-editors/kp-universal-form/types';
import type {DocumentDownloadUrlResponse} from './kp-availability-button/types';
import {ngAsync} from 'shared/utils/ng-@decorators';
import {transferify} from 'shared/utils/data-service-utils';
import type {AjaxService} from 'core/data-services/ajax.service';
import {SKIP_MODAL_WINDOW_INTERCEPTOR_HEADER} from 'src/modals/constants';

/**
 * @ngdoc service
 * @name loanRequestDataService
 * @module portaro.data-services
 *
 *
 * @description
 */
export default class LoanRequestDataService {
    public static serviceName = 'loanRequestDataService';

    private static readonly REQUESTS_ROUTE = '/loan-items/request';
    private static readonly REQUESTS_URL_ROUTE = '/loan-items/request/url';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async requestDocumentDownloadUrl(items: LoanRequestItem[]): Promise<DocumentDownloadUrlResponse | null> {
        return this.ajaxService
            .createRequest(`${LoanRequestDataService.REQUESTS_URL_ROUTE}`)
            .post(transferify(items));
    }


    // only type definitions
    public requestLoanForm(items: LoanRequestItem[]): Promise<LoanRequestFormActionResponse | RedirectionResponse>;
    public requestLoanForm(items: LoanRequestItem[], skipModalWindowInterceptor: true): Promise<LoanRequestFormActionResponse>;

    @ngAsync()
    public async requestLoanForm(items: LoanRequestItem[], skipModalWindowInterceptor = false): Promise<LoanRequestFormActionResponse | RedirectionResponse> {
        return this.ajaxService
                   .createRequest(`${LoanRequestDataService.REQUESTS_ROUTE}`)
                   .withHeaders(skipModalWindowInterceptor ? {[SKIP_MODAL_WINDOW_INTERCEPTOR_HEADER]: 'true'} : {})
                   .post(transferify(items));
    }

    @ngAsync()
    public async requestLoan(pathWithoutApiPrefix: string, loanRequest: LoanRequestTypes): Promise<ActionResponseWithText> {
        return this.ajaxService
            .createRequest(`${pathWithoutApiPrefix}`)
            .post(transferify(loanRequest));
    }

    @ngAsync()
    public async getDocumentCapabilityForm(capability: CapabilityName, params: DocumentCapabilitySlotsRequest): Promise<KpUniversalFormSettings<AnyObject>> {
        return this.ajaxService
            .createRequest(`${LoanRequestDataService.REQUESTS_ROUTE}/${capability}/form`)
            .post(transferify(params));
    }
}
